import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { JsonEditorComponent, JsonEditorOptions } from 'ang-jsoneditor';

@Component({
  selector: 'scaffold-json-editor',
  templateUrl: './json-editor.component.html',
  styleUrls: ['./json-editor.component.scss']
})
export class JsonDataComponent implements OnInit {
  public editorOptions: JsonEditorOptions;
  @ViewChildren(JsonEditorComponent) editors: QueryList<JsonEditorComponent>

  editor: JsonEditorComponent;
  _json: any;
  _object: any;
  error: string;
  _readonly = true;
  @Input('readonly')
  set readonly(v) {
    if (v) {
      this.editorOptions.modes = ['view'];
      this.editorOptions.mode = 'view';
    } else {
      this.editorOptions.modes = ['code', 'tree']; // set all allowed modes
      this.editorOptions.mode = 'tree';
      this._readonly = false
    }

  }
  @Output() jsonChange = new EventEmitter<any>();
  @Input('json')
  set json(v) {
    if (v) {

      try {
        let incoming = JSON.stringify(v, null, 2);
        if (incoming !== this._json) {
          this._json = incoming
          this._object = v;
        }

      } catch (e) {
        this.error = 'Invalid data object.'
      }
    }
  }
  get json() {
    return this._json;
  }


  constructor() {
    this.editorOptions = new JsonEditorOptions()
    this.editorOptions.expandAll = true
    this.editorOptions.onValidate = this.validate;
    this.editorOptions.onChangeText = this.changeLog.bind(this);
    console.log("Options:", this.editorOptions);
    this.editorOptions.mode = 'view';
    this.editorOptions.modes = ['view'];
    //this.options.mode = 'code'; //set only one mode
  }


  ngOnInit(): void {
  }


  changeLog(json: string) {
    this.error = null;
    this.getEditor();
    console.log(json);
    console.log('change:', this.editor);
    if (this.validate(json)) {
      let obj = JSON.parse(json);
      this._json = JSON.stringify(obj, null, 2);
      console.log(this._json)
    } else {
      this.error = 'Invalid data object.'
    }
  }

  getEditor() {
    if (!this.editor && this.editors) {
      console.log(this.editors)
      this.editor = this.editors.first;
    }
  }
  updateJson() {
    let output = this.validate(this.json);
    if (output) {
      this.jsonChange.emit(output);
    } else {
      this.error = 'Invalid JSON data.'
    }
  }

  validate(json) {
    console.log("validate")
    try {
      return JSON.parse(json);
    } catch (e) {
      return null;
    }
  }
}
